import React, { createContext, useContext, useState } from 'react'

export type ViewMode = 'table' | 'chart'

interface ViewModeContextType {
  viewMode: ViewMode
  setViewMode: (mode: ViewMode) => void
  toggleViewMode: () => void
}

const ViewModeContext = createContext<ViewModeContextType | undefined>(undefined)

interface ViewModeProviderProps {
  children: React.ReactNode
}

export const ViewModeProvider: React.FC<ViewModeProviderProps> = ({ children }) => {
  const [viewMode, setViewMode] = useState<ViewMode>('chart')

  const toggleViewMode = () => {
    setViewMode((prev) => (prev === 'table' ? 'chart' : 'table'))
  }

  return (
    <ViewModeContext.Provider value={{ viewMode, setViewMode, toggleViewMode }}>{children}</ViewModeContext.Provider>
  )
}

export const useViewMode = (): ViewModeContextType => {
  const context = useContext(ViewModeContext)
  if (!context) {
    throw new Error('useViewMode must be used within ViewModeProvider')
  }
  return context
}
